// extracted by mini-css-extract-plugin
var _1 = "zaYbV";
export { _1 as "base" }
